import VueDropzone from 'vue2-dropzone'
import excelParser from '../../../../services/excel-parser'
import locationService from '../../../../services/supplier/location'
import _ from 'lodash'
export default {
    components: {
        VueDropzone
    },
    data() {
        return {
            item: {},
            listHeader: [],
            isFileSelect: false,
            dropzoneOptions: {
                url: '#',
                acceptedFiles: '.xlsx,.xls,.csv',
                maxFiles: 1,
                maxFilesize: 1024,
                previewsContainer: false,
                autoProcessQueue: false
            }
        }
    },
    methods: {
        forceRerenderInsert() {
            this.$refs.modal.show()
        },

        addSuccess(file) {
            this.isFileSelect = false
            this.item = {
                file: null
            }

            if (file.name && _.isArray(file.name.split('.'))) {
                var ext = file.name.split('.')
                if (['xls','xlsx'].includes(ext[ext.length - 1])) {
                    this.item.file = file
                    try {
                        let formData = new FormData()
                        formData.append('file', this.item.file)
                        excelParser.getExcelHeaders(formData).then(res => {
                            if (!res.error) {
                                this.listHeader = res.data.d.map(x => { return { value: x, text: x } })
                                this.isFileSelect = true
                            }
                        })
                    } catch (e) {
                        console.clear()
                    }
                } else {
                    this._showToast('Only accept xls, xlsx, csv file format', { variant: 'danger' })
                }
            }
        },

        async save() {
            var isValid = await this.$refs['observer'].validate()
            if (isValid) {
                let formData = new FormData()
                formData.append('file', this.item.file)
                locationService.uploadFileWithoutProcessing(formData).then(res => {
                    if (!res.error) {
                        this._showNotify('Successfully uploaded', 'success')
                        this.$emit('onCompleted', 'UPDATE')
                        this.$refs.modal.hide()
                    }
                })
            }
        },
    }
}